import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import MapScreen from '../../containers/Map';
import ProductScreen from '../../containers/Product';
import ProductCustomizeScreen from '../../containers/ProductCustomizeScreen';
import ProfileLayout from '../../containers/Customer/Profile';
import ResetLayout from '../../containers/Customer/Reset';
import RecapLayout from '../../containers/Recap';
import OrderConfirmationView from '../Customer/Order/OrderConfirmView';
import DealsCustomizeScreen from '../../containers/Deals';
import AssertPayment from '../../containers/Payment/AssertPayment';
import TermsLayout from '../../components/App/TermsView';
import PrivacyPolicyLayout from '../../components/App/PrivacyPolicyView';
import Error404View from '../../components/App/Error404View';
import Error500View from '../../components/App/Error500View';
import ErrorTimeoutView from '../../components/App/ErrorTimeoutView';
import {PrivateRoute} from '../../routes';
import LanguageURLComponent from '../../containers/withlangaugeURL';

class MainViewComponent extends Component {

  render() {
    return (
      <main className="app__main">
        <Route path='/:lng?/*' component={LanguageURLComponent}/>
        <Switch>
          <Route exact path='/:lng?/:restaurant/products' component={ProductScreen}/>
          <Route exact path='/:lng?/:restaurant/products/:type' component={ProductScreen}/>
          <Route exact path='/:lng?/:restaurant/products/pizza/customize/:productId'
                 component={ProductCustomizeScreen}/>
          <Route exact path='/:lng?/:restaurant/products/deals/customize/:productId'
                 component={DealsCustomizeScreen}/>
          <Route exact path='/:lng?/reset/:uid/:token' component={ResetLayout}/>
          <Route exact path='/:lng?/order/confirm' component={OrderConfirmationView}/>
          <Route exact path='/:lng?/:restaurant/recap' component={RecapLayout}/>
          <Route exact path='/:lng?/pity' component={ErrorTimeoutView}/>
          <Route exact path='/:lng?/terms' component={TermsLayout}/>
          <Route exact path='/:lng?/policy' component={PrivacyPolicyLayout}/>
          <Route exact path='/:lng?/timeout' component={ErrorTimeoutView}/>
          <Route path="/not-found" component={Error404View}/>
          <Route path='/internal-error' component={Error500View}/>
          <PrivateRoute exact path='/:lng?/payment/assert/:type/:transactionId' component={AssertPayment}/>
          <PrivateRoute exact path='/:lng?/profile' component={ProfileLayout}/>
          <Route exact path='/:lng?' component={MapScreen}/>
          <Route path="*" component={Error404View}/>
        </Switch>
      </main>
    );
  }
}

export default MainViewComponent;


// WEBPACK FOOTER //
// ./src/components/Main/MainView.js